import React, {Component} from 'react';
import './decoration.css';

class DivideLine extends Component {
  render() {
  	 return(
	      <span className="DivideLine"> | </span>
	   );
  }
}

export default DivideLine;



// WEBPACK FOOTER //
// ./src/components/decoration/divideLine.js